import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCarrierInsuranceBanner = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCarrierInsuranceBanner);
};
